module.exports = __webpack_public_path__ + "img/riparian_info_landing_old.c859609c.png";